import moment from 'moment';

type SlaFields = { dueDate?: string; isOverdue?: boolean };

/**
 * SLA real do ticket (QA CORE-3377): `slaDays` NÃO é o SLA — o job diário do
 * mt-ticket grava nele a IDADE do ticket (hoje − abertura), então qualquer
 * cálculo "abertura + slaDays" resulta em ~hoje. O vencimento verdadeiro vem
 * pronto do backend em `dueDate`/`isOverdue` — sempre derive daqui.
 */
export function isSlaOverdue(item?: SlaFields | null): boolean {
  if (!item) return false;
  if (item.isOverdue) return true;
  if (!item.dueDate) return false;
  const due = moment(item.dueDate);
  return due.isValid() && due.endOf('day').isBefore(moment());
}

/** "SLA vencido" | "vence em Xd" | null (sem SLA definido) */
export function slaDueText(item?: SlaFields | null): string | null {
  if (!item) return null;
  if (isSlaOverdue(item)) return 'SLA vencido';
  if (!item.dueDate) return null;
  const due = moment(item.dueDate).endOf('day');
  if (!due.isValid()) return null;
  const days = Math.max(1, Math.ceil(due.diff(moment(), 'hours') / 24));
  return `vence em ${days} ${days > 1 ? 'dias' : 'dia'}`;
}

/** "SLA 15/06" | "SLA vencido" | null — rótulo curto para cabeçalhos de card */
export function slaShortLabel(item?: SlaFields | null): string | null {
  if (!item) return null;
  if (isSlaOverdue(item)) return 'SLA vencido';
  if (!item.dueDate) return null;
  const due = moment(item.dueDate);
  return due.isValid() ? `SLA ${due.format('DD/MM')}` : null;
}
